import { TabPanel, Tabs } from 'anf-core-react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import useFetchNavCategories from '../../hooks/useFetchNavCategories';
import useTabNavigation from '../../hooks/useTabNavigation';
import DraggableScroll from '../DraggableScroll/DraggableScroll';
import style from './GridCategories.module.scss';

const GridCategories = ({ currentCategoryId, parentCategoryId }) => {
  const { tabValues, defaultTab, handleChange } = useFetchNavCategories({
    parentCategoryId,
    currentCategoryId,
    mode: 'tabs',
  });

  const tabPanelIDs = [...tabValues.map((tab) => `${tab.id}-tabpanel`)];
  const initialTabPanelID = defaultTab?.id ? `${defaultTab.id}-tabpanel` : tabPanelIDs[0];
  const { refs, visibleTabID, handleTabKeyDown } = useTabNavigation(initialTabPanelID, tabPanelIDs);

  const { categoryTabs, categoryTabPanels } = useMemo(() => {
    const tabs = [];
    const panels = [];

    tabValues.forEach((tab, index) => {
      // Build tab configuration
      tabs.push({
        ariaControls: `${tab.id}-tabpanel`,
        id: `${tab.id}-tab`,
        isSelected: visibleTabID === `${tab.id}-tabpanel` || (defaultTab?.id === tab.id && !visibleTabID),
        label: tab.label,
        onClick: () => handleChange(tab),
        ref: refs[index],
        key: `${tab.id}-tab`,
      });

      // Build tab panel
      panels.push(
        <TabPanel
          key={`${tab.id}-tabpanel`}
          ariaLabelledBy={`${tab.id}-tab`}
          id={`${tab.id}-tabpanel`}
          isVisible={visibleTabID === `${tab.id}-tabpanel`}
        >
          <div />
        </TabPanel>,
      );
    });

    return { categoryTabs: tabs, categoryTabPanels: panels };
  }, [tabValues, visibleTabID, handleChange, refs, defaultTab]);

  const handleKeyDown = (event) => {
    const { code, currentTarget } = event;
    const selectedElement = currentTarget.querySelector('[aria-selected="true"]');
    if (!selectedElement) return;
    if (code === 'ArrowRight' || code === 'ArrowLeft') {
      handleTabKeyDown(event);
    }
  };

  return (
    <div className={classNames(style.gridCategories, 'scope-1892')} data-testid="grid-categories">
      <DraggableScroll className={style.dragContainer}>
        <Tabs
          controls={{
            onKeyDown: handleKeyDown,
            tabs: categoryTabs,
          }}
          labelText="Category Tabs"
        >
          {categoryTabPanels}
        </Tabs>
      </DraggableScroll>
    </div>
  );
};

GridCategories.propTypes = {
  currentCategoryId: PropTypes.string,
  parentCategoryId: PropTypes.string,
};

export default GridCategories;
